var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoltXImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 23,
    viewBox: "0 0 78 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.0139 5.33133L62.1003 1.65668C61.7502 1.23751 61.2459 0.972046 60.6996 0.972046H55.0126C54.5924 0.972046 54.3403 1.46107 54.6064 1.7964L61.0498 9.85828L65.0139 5.33133Z",
    fill: "#464AEB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8684 15.8802L70.2246 21.3433C70.5748 21.7624 71.0931 22.0279 71.6393 22.0279H77.1441C77.5643 22.0279 77.8165 21.5249 77.5503 21.2036L70.8269 12.6946L65.8684 15.8802Z",
    fill: "#464AEB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0566 1.57284L62.2965 10.3892C62.1565 10.5289 62.2825 10.7665 62.4786 10.7665H64.3276C64.5237 10.7665 64.6358 11.004 64.4957 11.1717L54.3824 21.5529C54.3264 21.6088 54.3964 21.7206 54.4665 21.6507L71.6674 10.515C71.8635 10.3892 71.7655 10.0958 71.5414 10.0958H67.8574C67.6333 10.0958 67.5353 9.81637 67.7174 9.69062L77.1163 1.86625C77.4804 1.55887 77.2563 0.958069 76.7941 0.958069H71.3873C70.869 0.972041 70.4068 1.19559 70.0566 1.57284Z",
    fill: "url(#paint0_linear_2385_3301)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.8662 6.04388V7.31534H43.1487V17.1936H41.734V7.31534H39.0166V6.04388H45.8662Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.2564 5.77844V15.6567H34.7442V16.9701H29.8276V5.77844H31.2564Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0622559 5.8064H1.79916C4.30647 5.89023 5.58113 6.8543 5.62315 8.74053C5.62315 9.78843 5.21694 10.5429 4.39051 10.99C4.69867 11.0739 4.89477 11.1577 5.03485 11.2136C6.15543 11.8004 6.6737 12.6527 6.6737 13.9242C6.6737 16.5649 3.85823 16.9421 3.10184 16.9561H3.08783H0.0622559V5.8064H1.79916H0.0622559ZM1.47699 11.8563V15.7126C2.24739 15.7126 2.73765 15.6986 2.97577 15.6707C3.14386 15.6707 3.28393 15.6567 3.38198 15.6287C3.70415 15.5868 3.97029 15.503 4.13838 15.4471C4.89477 15.1397 5.27297 14.5529 5.27297 13.7705C5.24495 12.3733 3.99831 11.7166 1.47699 11.8563ZM1.50501 7.04991V10.7525C1.96725 10.7525 2.28942 10.7385 2.4575 10.7385C2.6396 10.7246 2.77967 10.6966 2.90574 10.6826C3.41 10.5848 3.73217 10.4032 3.90025 10.2216C4.1804 9.91418 4.30647 9.4531 4.30647 8.92216C4.30647 8.46109 4.22242 8.02795 3.99831 7.74851C3.83022 7.5529 3.53606 7.30141 3.0318 7.2036C2.79368 7.11977 2.28942 7.07785 1.50501 7.04991Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9494 5.55487C21.2552 5.55487 23.9025 8.16765 23.9025 11.3812C23.9025 14.5948 21.2271 17.1936 17.9494 17.1936C14.6717 17.1936 11.9963 14.5808 11.9963 11.3672C11.9963 8.15367 14.6717 5.55487 17.9494 5.55487ZM17.9774 6.82633C15.4701 6.82633 13.4251 8.86625 13.4251 11.3533C13.4251 13.8403 15.4701 15.8802 17.9774 15.8802C20.4848 15.8802 22.5298 13.8403 22.5298 11.3533C22.5298 8.86625 20.4848 6.82633 17.9774 6.82633Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8989 9.13171L19.5043 11.3812L16.8989 13.6167V9.13171Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2385_3301",
    x1: 55.4778,
    y1: 19.6184,
    x2: 76.1461,
    y2: 1.28887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1747,
    stopColor: "#454AEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#61C2ED"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoltXImage);
export default __webpack_public_path__ + "static/media/boltXImage.e03a287d42656d13ee2e38b3b5cedbbf.svg";
export { ForwardRef as ReactComponent };